//a module to check if the React App/React Bundle is running in the App.

import isStolApp from '../is-stolapp'

const createValidRelativeUrl = (urlString) => {
  if (!urlString) {
    return
  }
  const isStol = urlString.includes('stol.it')
  if (isStolApp() || !isStol) {
    return urlString
  }

  try {
    return new URL(urlString).pathname
  } catch (e) {
    return urlString
  }
}

export default createValidRelativeUrl
